import { combineReducers } from 'redux'
import app from './appReducer'
import locale from './localeReducer'
import member from './memberReducer'
import plan from './planReducer'
import broker from './brokerReducer'
import application from './applicationReducer'

const rootReducer = routerReducer =>
  combineReducers({
    router: routerReducer,
    app, // system
    application, // enrolment entity
    locale,
    member,
    plan,
    broker
  })

export default rootReducer
